<!-- Loading bar -->
<zop-loading-bar></zop-loading-bar>

<!-- Navigation -->
<ng-container *ngIf="isScreenSmall && navigation">
    <zop-vertical-navigation 
        class="bg-white text-gray-900 dark:bg-gray-900 dark:text-white print:hidden" 
        [mode]="'over'" 
        [name]="'mobileNavigation'"
        [navigation]="navigation.default" 
        [opened]="false">
        <!-- Navigation header hook -->
        <ng-container zopVerticalNavigationContentHeader>
            <!-- Logo -->
            <div class="flex items-center h-20 pt-6 px-8">
                <img class="w-24" src="assets/images/logo/verified-text.svg" alt="Verified">
            </div>
        </ng-container>
    </zop-vertical-navigation>
</ng-container>

<!-- Wrapper -->
<div class="flex flex-col flex-auto w-full min-w-0">

    <!-- Header -->
    <div *ngIf="!config?.hideHeader"
        class="relative flex flex-0 items-center w-full h-16 sm:h-20 px-4 md:px-6 z-49 shadow dark:shadow-none dark:border-b bg-card dark:bg-transparent print:hidden">
        <ng-container *ngIf="!isScreenSmall && navigation">
            <!-- Logo -->
            <div class="flex items-center mx-2 lg:mr-8">
                <div class="hidden lg:flex">
                    <img class="dark:hidden h-8" src="assets/images/logo/verified-text.svg">
                    <img class="hidden dark:flex h-8" src="assets/images/logo/verified-text.svg">
                </div>
                <img class="flex lg:hidden h-8" src="assets/images/logo/verified-text.svg">
            </div>
            <!-- Horizontal navigation -->
            <zop-horizontal-navigation class="mr-2" [name]="'desktopNavigation'"
                [navigation]="navigation.horizontal"></zop-horizontal-navigation>
        </ng-container>
        <!-- Navigation toggle button -->
        <ng-container *ngIf="isScreenSmall">
            <button mat-icon-button (click)="toggleNavigation('mobileNavigation')">
                <mat-icon [svgIcon]="'heroicons_outline:bars-3'"></mat-icon>
            </button>
        </ng-container>
        <!-- Components -->
        <div class="flex items-center pl-2 ml-auto space-x-0.5 sm:space-x-2">
            <zop-languages></zop-languages>
            <!-- <zop-full-screen class="hidden md:block"></zop-full-screen> -->
            <!-- <zop-shortcuts></zop-shortcuts> -->
            <!-- <zop-notifications></zop-notifications> -->
        </div>
    </div>

    <!-- Content -->
    <div class="flex flex-col flex-auto w-full">
        <!-- *ngIf="true" hack is required here for router-outlet to work correctly.
             Otherwise, layout changes won't be registered and the view won't be updated! -->
        <router-outlet *ngIf="true"></router-outlet>
    </div>

    <!-- Footer -->
    <ng-container *ngIf="!config?.hideFooter">
        <!-- Simple Footer -->
        <div *ngIf="config.footerStyle !== 'detailed'"
            class="relative flex flex-0 items-center w-full h-14 sm:h-20 px-4 md:px-6 z-49 border-t bg-card dark:bg-transparent print:hidden">
            <span class="font-medium text-secondary">{{config.copyWriteText}} &copy; {{currentYear}}</span>
        </div>

        <!-- Detailed Footer -->
        <zop-footer *ngIf="config.footerStyle === 'detailed'" [config]="config"></zop-footer>
    </ng-container>


</div>